import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from "@angular/core"; import { Location } from "@angular/common";
import { Observable, of } from 'rxjs';
import { environment } from '../../environments/environment';
import { Router } from '@angular/router';
import { ReponseBase } from './reponse-base';
import { ItemService } from './item-service';
import { EntretienPreventifEntite } from '../entites/mecanique/entretien-preventif';
import { ESeverites } from '../entites/enums/severites';
import { HistoriqueEntretienPreventifEntite } from '../entites/mecanique/historique-entretien-preventif';
import { DonneesBaseService } from './donnees-base-service';
import { EStatuts } from '../entites/enums/statuts';
import { MajService } from './maj-service';

@Injectable({ providedIn: 'root' })
export class EntretienPreventifService {

  private obtenirUrl = environment.apiBaseUrl + 'entretienpreventif';
  private obtenirParItemUrl = environment.apiBaseUrl + 'entretienpreventif/item/{id}';
  private obtenirArchivesParItemUrl = environment.apiBaseUrl + 'entretienpreventif/item/{id}/archives';
  private detailUrl = environment.apiBaseUrl + 'entretienpreventif/{id}';
  private creerUrl = environment.apiBaseUrl + 'entretienpreventif';
  private modifierUrl = environment.apiBaseUrl + 'entretienpreventif/modifier';
  private supprimerUrl = environment.apiBaseUrl + 'entretienpreventif/{id}';
  private reactiverUrl = environment.apiBaseUrl + 'entretienpreventif/{id}/reactiver';
  private historiqueUrl = environment.apiBaseUrl + 'entretienpreventif/historique/{id}';
  private reclaculerUrl = environment.apiBaseUrl + 'entretienpreventif/recalculer/{itemId}';
  

  public httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
  };

  constructor(
    private sdb: DonneesBaseService,
    public itemService: ItemService,
    private majService: MajService,
    private http: HttpClient,

    public router: Router) { }

    public Obtenir(): Promise<ReponseBase<EntretienPreventifEntite[]>> {
      var p = this.http.get<ReponseBase<EntretienPreventifEntite[]>>(this.obtenirUrl)
        .toPromise();
        p.catch(() => this.router.navigateByUrl('error'));
        return p;
    }

    public ObtenirDetail(id: number): Promise<ReponseBase<EntretienPreventifEntite>> {
      var p = this.http.get<ReponseBase<EntretienPreventifEntite>>(this.detailUrl.replace('{id}', id.toString()))
        .toPromise();
        p.catch(() => this.router.navigateByUrl('error'));
        return p;
    }

    public ObtenirParItem(id: number): Promise<ReponseBase<EntretienPreventifEntite[]>> {
      var p = this.http.get<ReponseBase<EntretienPreventifEntite[]>>(this.obtenirParItemUrl.replace('{id}', id.toString()))
        .toPromise();
        p.catch(() => this.router.navigateByUrl('error'));
        return p;
    }

    public ObtenirArchivesParItem(id: number): Promise<ReponseBase<EntretienPreventifEntite[]>> {
      var p = this.http.get<ReponseBase<EntretienPreventifEntite[]>>(this.obtenirArchivesParItemUrl.replace('{id}', id.toString()))
        .toPromise();
        p.catch(() => this.router.navigateByUrl('error'));
        return p;
    }

    public ObtenirHistorique(id: number): Promise<ReponseBase<HistoriqueEntretienPreventifEntite[]>> {
      var p = this.http.get<ReponseBase<HistoriqueEntretienPreventifEntite[]>>(this.historiqueUrl.replace('{id}', id.toString()))
        .toPromise();
        p.catch(() => this.router.navigateByUrl('error'));
        return p;
    }

    public Creer(entretien: EntretienPreventifEntite): Promise<ReponseBase<EntretienPreventifEntite>> {
      var p = this.http.post<ReponseBase<EntretienPreventifEntite>>(this.creerUrl, JSON.stringify(entretien), this.httpOptions)
        .toPromise();
        p.then(() => this.majService.Traiter());
        p.catch(() => this.router.navigateByUrl('error'));
        return p;
    }

    public Modifier(entretien: EntretienPreventifEntite): Promise<ReponseBase<EntretienPreventifEntite>> {
      var p = this.http.post<ReponseBase<EntretienPreventifEntite>>(this.modifierUrl, JSON.stringify(entretien), this.httpOptions)
        .toPromise();
        p.then(() => this.majService.Traiter());
        p.catch(() => this.router.navigateByUrl('error'));
        return p;
    }
  
    public Supprimer(id: number): Promise<ReponseBase<number>> {
      var p = this.http.delete<ReponseBase<number>>(this.supprimerUrl.replace('{id}', id.toString()))
        .toPromise();
        p.catch(() => this.router.navigateByUrl('error'));
        return p;
    }

    public Reactiver(id: number): Promise<ReponseBase<number>> {
      var p = this.http.post<ReponseBase<number>>(this.reactiverUrl.replace('{id}', id.toString()), null, this.httpOptions)
        .toPromise();
        p.then(() => this.majService.Traiter());
        p.catch(() => this.router.navigateByUrl('error'));
        return p;
    }

    public Recalculer(id: number): Promise<ReponseBase<number>> {
      var p = this.http.post<ReponseBase<number>>(this.reclaculerUrl.replace('{itemId}', id.toString()), null, this.httpOptions)
        .toPromise();
        p.then(() => this.majService.Traiter());
        p.catch(() => this.router.navigateByUrl('error'));
        return p;
    }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      console.error(error);

      this.log(`${operation} failed: ${error.message}`);

      this.router.navigateByUrl('erreurtechnique');

      return of(result as T);
    };
  }

  private log(message: string) {
      console.log(message);
  }
}
